






import { useEffect, useState } from "react";
import { getAssignedTasksApi, getEmployeesApi } from "../../app/api";
import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Eye } from "lucide-react";
import { Package } from "lucide-react";
import { useTaskStore } from "../../app/taskStore";
const IMAGE_BASE_URL = "https://uptask.visiontrek.io";

export default function AssignedTasks() {
  const setCounts = useTaskStore((state) => state.setCounts);
  const setSelectedStatusFilter = useTaskStore((state) => state.setSelectedStatusFilter);



  const [employeeSearch, setEmployeeSearch] = useState("");
const [startDate, setStartDate] = useState("");
const [endDate, setEndDate] = useState("");
  const [tasks, setTasks] = useState([]);
  const [filter, setFilter] = useState("ALL");
  const navigate = useNavigate();
  const [employees, setEmployees] = useState([]);



  const [showAssigneeModal, setShowAssigneeModal] = useState(false);
const [selectedAssignees, setSelectedAssignees] = useState([]);


const getAssignees = (task) => {
  const names = task.assigned_to_names?.split(",") || [];
  const pics = task.assigned_to_profile_pics?.split(",") || [];

  return names.map((name, i) => ({
    name: name.trim(),
    pic: pics[i] || null,
  }));
};





  const loadTasks = async () => {
    try {
      const res = await getAssignedTasksApi();
      const loggedInUser = JSON.parse(localStorage.getItem("user"));

      if (res.success) {
        const filteredTasks = res.data.filter(
          (task) => Number(task.created_by) === Number(loggedInUser.id)
        );
        setTasks(filteredTasks);
      } else {
        toast.error("Failed to load assigned tasks");
      }
    } catch (err) {
      toast.error("Error fetching tasks");
    }
  };

  useEffect(() => {
    loadTasks();
    getEmployeesApi().then(res => {
      if (res.success) setEmployees(res.data || []);
    });

    // Clear status filter when leaving this page
    return () => {
      setSelectedStatusFilter(null);
    };
  }, []);

  // ✅ Update KPI counts whenever tasks change
  useEffect(() => {
    const counts = {
      TODO: 0,
      IN_PROGRESS: 0,
      HOLD: 0,
      REVIEW: 0,
      DONE: 0,
    };
    tasks.forEach((t) => {
      const key = t.status ? t.status.replace(" ", "_") : "";
      if (counts[key] !== undefined) counts[key]++;
    });
    setCounts(counts);
  }, [tasks, setCounts]);

  // ✅ FILTER LOGIC (UI only)
  // const filteredTasks = tasks.filter((task) => {
  //   if (filter === "COMPLETED") return task.status === "DONE";
  //   if (filter === "HIGH") return task.priority === "HIGH";
  //   return true;
  // });


  const filteredTasks = tasks.filter((task) => {
    // ✅ Button filters
    if (filter === "COMPLETED" && task.status !== "DONE") return false;
    if (filter === "HIGH" && task.priority !== "HIGH") return false;
  
    // ✅ Employee filter
    if (employeeSearch) {
      const names = task.assigned_to_names?.toLowerCase() || "";
      if (!names.includes(employeeSearch.toLowerCase())) return false;
    }
  
    // ✅ Date filter
    const createdDate = task.created_at
      ? new Date(task.created_at.split(" ")[0])
      : null;
  
    const start = startDate ? new Date(startDate) : null;
    const end = endDate ? new Date(endDate) : null;
  
    if (start && createdDate && createdDate < start) return false;
    if (end && createdDate && createdDate > end) return false;
  
    return true;
  });





  return (
    <div className="p-6 text-white md:mt-20   bg-[#12082F]
  backdrop-blur-2xl
  border border-white/10
  shadow-[0_40px_100px_-20px_rgba(0,0,0,0.7)] rounded-[20px]">
         {/* <div className=" bg-[#1b153f] p-8 md:mt-4 mt-2 rounded-[20px]"></div> */}

      {/* ================= FILTER BAR ================= */}
      {/* <div className=" p-4 rounded-xl mb-6 flex flex-wrap items-center gap-3 justify-between"> */}
      <div className=" flex flex-wrap items-center gap-3 justify-between mb-8 p-2 rounded-lg bg-white/5 border border-white/10 backdrop-blur-3xl animate-in slide-in-from-top-4 duration-500">

        {/* LEFT FILTER BUTTONS */}
        <div className="flex gap-0.5 md:gap-2">
          <button
            onClick={() => setFilter("ALL")}
            className={`px-4 py-2 rounded-lg ${
              filter === "ALL" ? "bg-indigo-600" : "bg-white/5 border border-white/10"
            }`}
          >

{/* className="bg-white/5 border border-white/10 rounded-lg px-5 py-1 text-sm text-white placeholder-white outline-none focus:border-indigo-500/50" */}

            All
          </button>

          <button
            onClick={() => setFilter("COMPLETED")}
            className={`px-2 py-2 rounded-lg ${
              filter === "COMPLETED" ? "bg-green-600" : "bg-white/5 border border-white/10"
            }`}
          >
            Completed
          </button>

          <button
            onClick={() => setFilter("HIGH")}
            className={`px-2 py-2 rounded-lg ${
              filter === "HIGH" ? "bg-red-500" : "bg-white/5 border border-white/10 whitespace-nowrap"
            }`}
          >
            High Priority
          </button>
        </div>

        {/* RIGHT FILTERS */}
        <div className="flex gap-2 flex-wrap">
          {/* <input
            type="text"
            placeholder="Search employee..."
            // className="px-3 py-2 rounded bg-white/10 outline-none"
            className="bg-white/5 border border-white/10 rounded-lg px-5 py-1 text-sm text-white placeholder-white outline-none focus:border-indigo-500/50"

          />
          <input
            type="date"
            className="bg-white/5 border border-white/10 rounded-lg px-5 py-1 text-sm text-white placeholder-white outline-none focus:border-indigo-500/50"
          />
          <input
            type="date"
            className="bg-white/5 border border-white/10 rounded-lg px-5 py-1 text-sm text-white placeholder-white outline-none focus:border-indigo-500/50"
          /> */}




<input
  type="text"
  placeholder="Search employee..."
  value={employeeSearch}
  onChange={(e) => setEmployeeSearch(e.target.value)}
  className="bg-white/5 border border-white/10 rounded-lg px-5 py-1 text-sm text-white"
/>

<input
  type="date"
  value={startDate}
  onChange={(e) => setStartDate(e.target.value)}
  className="bg-white/5 border border-white/10 rounded-lg px-5 py-1 text-sm text-white"
/>

<input
  type="date"
  value={endDate}
  onChange={(e) => setEndDate(e.target.value)}
  className="bg-white/5 border border-white/10 rounded-lg px-5 py-1 text-sm text-white"
/>

          <button className="px-4 py-2 bg-indigo-600 rounded  hover:bg-indigo-500">
            Apply
          </button>

          {/* <button className="px-4 py-2 bg-gray-500 rounded">
            Clear
          </button> */}

<button
  onClick={() => {
    setFilter("ALL");
    setEmployeeSearch("");
    setStartDate("");
    setEndDate("");
  }}
  className="px-4 py-2 bg-gray-500 rounded hover:bg-gray-600"
>
  Clear
</button>
        </div>
      </div>

      {/* ================= TASK CARDS ================= */}
      {filteredTasks.length === 0 ? (
        // <p>No assigned tasks</p>
    <div className="flex flex-col items-center justify-center h-[300px]">
              <Package size={40} className="text-white/30 mb-3" />
              <p className="text-white/60 text-sm">
                No assigned items
              </p>
            </div>
      ) : (



        
        <div className="grid md:grid-cols-4 gap-5">



          {filteredTasks.map((task) => (
            <div
              key={task.id}
              className="p-4 rounded-2xl border border-white/10 
              bg-gradient-to-br from-[#1e1b4b] to-[#312e81] shadow-lg"
            >
              {/* TITLE + PRIORITY */}
              <div className="flex justify-between items-start">
                <h3 className="font-semibold text-sm">{task.title}</h3>

                <span
                  className={`text-xs px-2 py-1 rounded-full ${
                    task.priority === "HIGH"
                      ? "bg-red-500/20 text-red-400"
                      : "bg-yellow-500/20 text-yellow-300"
                  }`}
                >
                  {task.priority}
                </span>
              </div>

              {/* ASSIGNEE */}
              {/* <div className="flex items-center gap-2 mt-3">
                {task.assigned_to_profile_pics ? (
                  <img
                    src={`${IMAGE_BASE_URL}${task.assigned_to_profile_pics}`}
                    className="w-8 h-8 rounded-full object-cover"
                  />
                ) : (
                  <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center text-xs">
                    {task.assigned_to_names?.charAt(0)}
                  </div>
                )}

                <span className="text-sm">
                  {task.assigned_to_names}
                </span>
              </div> */}




{(() => {
  const assignees = getAssignees(task);
  const count = assignees.length;

  if (count === 0) return null;

  const visibleUsers = assignees.slice(0, 2);

  return (
    <div className="flex items-center gap-2 mt-[-8px]">

      {/* 👤 AVATAR STACK */}
      <div className="flex -space-x-2 mt-4">
        {visibleUsers.map((user, i) =>
          user.pic ? (
            <img
              key={i}
              src={`${IMAGE_BASE_URL}${user.pic}`}
              onError={(e) => (e.target.src = "/avatar.png")}
              className="w-8 h-8 rounded-full object-cover border border-white"
            />
          ) : (
            <div
              key={i}
              className="w-8 h-8 rounded-full bg-blue-600 flex items-center justify-center text-white text-xs border border-white"
            >
              {user.name?.charAt(0).toUpperCase()}
            </div>
          )
        )}

        {/* ➕ EXTRA COUNT */}
        {count > 2 && (
          <div className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center text-[10px] text-white border border-white">
            +{count - 2}
          </div>
        )}
      </div>

      {/* 👁 SHOW ONLY IF MULTIPLE */}
      {count > 1 && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            setSelectedAssignees(assignees);
            setShowAssigneeModal(true);
          }}
          className="text-white/70 hover:text-white mt-4"
        >
          <Eye size={16} />
        </button>
      )}

      {/* 👤 NAME ONLY FOR SINGLE USER */}
      {count === 1 && (
        <p className="text-xs text-gray-300 ml-1">
          {assignees[0].name}
        </p>
      )}
    </div>
  );
})()}

              {/* DATES */}
              <div className="flex justify-between text-xs text-gray-300 mt-4">
                <div>
                  <p>Created</p>
                  <p>{task.created_at?.split(" ")[0]}</p>
                </div>
                <div>
                  <p>Due</p>
                  <p>{task.due_date?.split(" ")[0]}</p>
                </div>
              </div>

              {/* PROGRESS BAR (STATIC) */}
              <div className="mt-3">
                <div className="h-1 bg-white/20 rounded">
                  <div className="h-1 bg-indigo-500 w-0 rounded"></div>
                </div>
                <p className="text-xs text-right mt-1">0%</p>
              </div>

              {/* CREATOR */}
              <div className="flex items-center gap-2 mt-4">
                {task.creator_profile_pic ? (
                  <img
                    src={`${IMAGE_BASE_URL}${task.creator_profile_pic}`}
                    className="w-6 h-6 rounded-full"
                  />
                ) : (
                  <div className="w-6 h-6 bg-gray-500 rounded-full"></div>
                )}

                <span className="text-xs text-gray-300">
                  {task.creator}
                </span>

                <span className="ml-auto text-xs bg-cyan-500/20 px-2 py-1 rounded">
                  {task.status}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}










{showAssigneeModal &&
  createPortal(
    <div className="fixed inset-0 z-[9999] flex items-center justify-center">

      {/* BACKDROP */}
      <div
        className="absolute inset-0 bg-black/60 backdrop-blur-md"
        onClick={() => setShowAssigneeModal(false)}
      />

      {/* MODAL */}
      <div className="relative w-[350px] max-w-[90%] bg-[#1e1447]/90 backdrop-blur-xl border border-white/20 rounded-xl p-5 text-white">

        <h3 className="text-lg font-semibold mb-4 text-center">
          Assignees
        </h3>

        <div className="space-y-3 max-h-[300px] overflow-y-auto">

          {selectedAssignees.map((user, i) => (
            <div
              key={i}
              className="flex items-center gap-3 p-2 rounded-lg hover:bg-white/10 cursor-pointer"
              onClick={() => {
                // navigate(`/users/${user.id}?tab=task`);
                setShowAssigneeModal(false);
              }}
            >
              {/* {user.pic ? (
                <img
                  src={`${IMAGE_BASE_URL}${user.pic}`}
                  className="w-8 h-8 rounded-full object-cover"
                />
              ) : (
                <div className="w-8 h-8 rounded-full bg-blue-600 flex items-center justify-center text-white text-xs">
                  {user.name?.charAt(0).toUpperCase()}
                </div>
              )} */}

<div className="w-8 h-8 rounded-full bg-blue-600 flex items-center justify-center text-white text-xs">
                  {user.name?.charAt(0).toUpperCase()}
                </div>

              <span className="text-sm">{user.name}</span>
            </div>
          ))}

        </div>

        <button
          onClick={() => setShowAssigneeModal(false)}
          className="mt-4 w-full py-2 bg-gradient-to-r from-cyan-500 to-blue-500 rounded-lg"
        >
          Close
        </button>
      </div>
    </div>,
    document.body
  )}





    </div>
  );
}










// import { useEffect, useState } from "react";
// import { getAssignedTasksApi } from "../../app/api";
// import { toast } from "react-toastify";

// const IMAGE_BASE_URL = "https://uptask.visiontrek.io";

// export default function AssignedTasks() {
//   const [tasks, setTasks] = useState([]);
//   const [filter, setFilter] = useState("ALL");

//   const loadTasks = async () => {
//     try {
//       const res = await getAssignedTasksApi();
//       const loggedInUser = JSON.parse(localStorage.getItem("user"));

//       if (res.success) {
//         const filteredTasks = res.data.filter(
//           (task) => Number(task.created_by) === Number(loggedInUser.id)
//         );
//         setTasks(filteredTasks);
//       } else {
//         toast.error("Failed to load assigned tasks");
//       }
//     } catch (err) {
//       toast.error("Error fetching tasks");
//     }
//   };

//   useEffect(() => {
//     loadTasks();
//   }, []);

//   // ✅ FILTER LOGIC (UI only)
//   const filteredTasks = tasks.filter((task) => {
//     if (filter === "COMPLETED") return task.status === "DONE";
//     if (filter === "HIGH") return task.priority === "HIGH";
//     return true;
//   });

//   return (
//     <div className="p-6 text-white md:mt-20 bg-[#1b153f] rounded-[20px]">
//          {/* <div className=" bg-[#1b153f] p-8 md:mt-4 mt-2 rounded-[20px]"></div> */}

//       {/* ================= FILTER BAR ================= */}
//       {/* <div className=" p-4 rounded-xl mb-6 flex flex-wrap items-center gap-3 justify-between"> */}
//       <div className=" flex flex-wrap items-center gap-3 justify-between mb-8 p-4 rounded-lg bg-white/5 border border-white/10 backdrop-blur-3xl animate-in slide-in-from-top-4 duration-500">

//         {/* LEFT FILTER BUTTONS */}
//         <div className="flex gap-2">
//           <button
//             onClick={() => setFilter("ALL")}
//             className={`px-4 py-2 rounded-lg ${
//               filter === "ALL" ? "bg-indigo-600" : "bg-white/5 border border-white/10"
//             }`}
//           >

// {/* className="bg-white/5 border border-white/10 rounded-lg px-5 py-1 text-sm text-white placeholder-white outline-none focus:border-indigo-500/50" */}

//             All
//           </button>

//           <button
//             onClick={() => setFilter("COMPLETED")}
//             className={`px-4 py-2 rounded-lg ${
//               filter === "COMPLETED" ? "bg-green-600" : "bg-white/5 border border-white/10"
//             }`}
//           >
//             Completed
//           </button>

//           <button
//             onClick={() => setFilter("HIGH")}
//             className={`px-4 py-2 rounded-lg ${
//               filter === "HIGH" ? "bg-red-500" : "bg-white/5 border border-white/10"
//             }`}
//           >
//             High Priority
//           </button>
//         </div>

//         {/* RIGHT FILTERS */}
//         <div className="flex gap-2 flex-wrap">
//           <input
//             type="text"
//             placeholder="Search employee..."
//             // className="px-3 py-2 rounded bg-white/10 outline-none"
//             className="bg-white/5 border border-white/10 rounded-lg px-5 py-1 text-sm text-white placeholder-white outline-none focus:border-indigo-500/50"

//           />
//           <input
//             type="date"
//             className="bg-white/5 border border-white/10 rounded-lg px-5 py-1 text-sm text-white placeholder-white outline-none focus:border-indigo-500/50"
//           />
//           <input
//             type="date"
//             className="bg-white/5 border border-white/10 rounded-lg px-5 py-1 text-sm text-white placeholder-white outline-none focus:border-indigo-500/50"
//           />

//           <button className="px-4 py-2 bg-indigo-600 rounded">
//             Apply
//           </button>

//           <button className="px-4 py-2 bg-gray-500 rounded">
//             Clear
//           </button>
//         </div>
//       </div>

//       {/* ================= TASK CARDS ================= */}
//       {filteredTasks.length === 0 ? (
//         <p>No assigned tasks</p>
//       ) : (



        
//         <div className="grid md:grid-cols-4 gap-5">



//           {filteredTasks.map((task) => (
//             <div
//               key={task.id}
//               className="p-4 rounded-2xl border border-white/10 
//               bg-gradient-to-br from-[#1e1b4b] to-[#312e81] shadow-lg"
//             >
//               {/* TITLE + PRIORITY */}
//               <div className="flex justify-between items-start">
//                 <h3 className="font-semibold text-sm">{task.title}</h3>

//                 <span
//                   className={`text-xs px-2 py-1 rounded-full ${
//                     task.priority === "HIGH"
//                       ? "bg-red-500/20 text-red-400"
//                       : "bg-yellow-500/20 text-yellow-300"
//                   }`}
//                 >
//                   {task.priority}
//                 </span>
//               </div>

//               {/* ASSIGNEE */}
//               <div className="flex items-center gap-2 mt-3">
//                 {task.assigned_to_profile_pics ? (
//                   <img
//                     src={`${IMAGE_BASE_URL}${task.assigned_to_profile_pics}`}
//                     className="w-8 h-8 rounded-full object-cover"
//                   />
//                 ) : (
//                   <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center text-xs">
//                     {task.assigned_to_names?.charAt(0)}
//                   </div>
//                 )}

//                 <span className="text-sm">
//                   {task.assigned_to_names}
//                 </span>
//               </div>

//               {/* DATES */}
//               <div className="flex justify-between text-xs text-gray-300 mt-4">
//                 <div>
//                   <p>Created</p>
//                   <p>{task.created_at?.split(" ")[0]}</p>
//                 </div>
//                 <div>
//                   <p>Due</p>
//                   <p>{task.due_date?.split(" ")[0]}</p>
//                 </div>
//               </div>

//               {/* PROGRESS BAR (STATIC) */}
//               <div className="mt-3">
//                 <div className="h-1 bg-white/20 rounded">
//                   <div className="h-1 bg-indigo-500 w-0 rounded"></div>
//                 </div>
//                 <p className="text-xs text-right mt-1">0%</p>
//               </div>

//               {/* CREATOR */}
//               <div className="flex items-center gap-2 mt-4">
//                 {task.creator_profile_pic ? (
//                   <img
//                     src={`${IMAGE_BASE_URL}${task.creator_profile_pic}`}
//                     className="w-6 h-6 rounded-full"
//                   />
//                 ) : (
//                   <div className="w-6 h-6 bg-gray-500 rounded-full"></div>
//                 )}

//                 <span className="text-xs text-gray-300">
//                   {task.creator}
//                 </span>

//                 <span className="ml-auto text-xs bg-cyan-500/20 px-2 py-1 rounded">
//                   {task.status}
//                 </span>
//               </div>
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// }